import { createReducer, on } from '@ngrx/store';
import { TableComponentState } from '../../shared/types/TableComponentState';
import { InternalTransferActions, InternalTransfersActions, PositionsTableActions } from '../actions';

export const positionsLotsTableStateKey = 'positionsLotsTableState';

export interface State extends TableComponentState {
  isEdit: boolean;
}

export const intialPositionsLotsTableState: State = {
  loading: false,
  error: '',
  hasError: false,
  gridReady: false,
  isInitialLoad: true,
  printClicked: false,
  isEdit: false
};

export const positionsLotsTableStateReducer = createReducer(
  intialPositionsLotsTableState,
  on(PositionsTableActions.gridReady, (state, action) => {
    return {
      ...state,
      gridReady: action.gridReady,
    };
  }),
  on(
    InternalTransferActions.loadPositions,
    InternalTransfersActions.itLoadPositions,
    PositionsTableActions.refresh,
    (state) => {
      return {
        ...state,
        loading: true,
        error: '',
        hasError: false,
        isInitialLoad: false,
      };
    }
  ),
  on(InternalTransferActions.loadPositionsSuccessful,
    InternalTransfersActions.itLoadPositionsSuccessful,
    PositionsTableActions.refresh,
    (state) => {
      return {
        ...state,
        loading: false,
        error: '',
        hasError: false,
        isInitialLoad: false,
       };
     }
  ),
  on(InternalTransferActions.loadPositionsFail,
    InternalTransfersActions.itLoadPositionsFail,
    PositionsTableActions.refresh,
    (state) => {
      return {
        ...state,
        loading: false,
        error: 'error calling positions-lot endpoint',
        hasError: true,
        isInitialLoad: false,
        isEdit: false
       };
     }
  ),
  on(InternalTransferActions.clearToAccount,
    PositionsTableActions.toAccountNotInContext,
    (state) => {
      return {
        ...state,
        loading: false,
        error: '',
        hasError: false,
        isInitialLoad: true,
        isEdit: false
       };
     }
  ),
  on(PositionsTableActions.printClicked, (state) => {
    return {
      ...state,
      printClicked: true
    };
  }),
  on(PositionsTableActions.loadEdit,
    (state) => {
      return {
        ...state,
        loading: false,
        error: '',
        hasError: false,
        isInitialLoad: false,
        isEdit: true
       };
     }
  ),
  on(PositionsTableActions.loadEditComplete,
    (state) => {
      return {
        ...state,
        isEdit: false
       };
     }
  ),
);
